export default [
  {
    path: '',
    name: 'sofono',
    component: () => import(/* webpackChunkName: "sofono" */ '@/apps/sofono/pages/SofonoPage.vue')
  }
]
